import {Component, OnInit, ViewChild} from '@angular/core';
import {Table} from "primeng/table";
import {NavService} from "../../../_services/_nav.service";
import {Router} from "@angular/router";
import {TasasVariablesService} from "../../../_services/tasas-variables.service";
import {RolFuncionalitiesServices} from "../../../_services/rol-funcionalidad.service";
import {AutenticacionService} from "../../../_services/autenticacion.service";

@Component({
  selector: 'app-tasas-variables-listado',
  templateUrl: './tasas-variables-listado.component.html',
  styleUrls: ['./tasas-variables-listado.component.css']
})
export class TasasVariablesListadoComponent implements OnInit {

  lisTasas: any[] = [];
  carTabla = true;
  columnas: any[];
  carInformacionInicial: boolean = true;
  botonVisible = false;
  @ViewChild('dt') tabla: Table;
  constructor(private navServicio: NavService,
              private router: Router,
              private authService: AutenticacionService,
              private rolFuncionalidadService: RolFuncionalitiesServices,
              private tasasVariablesService: TasasVariablesService) { }

  async ngOnInit() {
    const permiso = await this.rolFuncionalidadService.getByCodigoPadreCodigoHijo( 'ADTAVA', 'ADTAVA', 'ACTCON' ).toPromise();
    this.botonVisible = !!permiso.find( x => !!this.authService.obtenerRolesUsuarios().find( y => x.codigoRol === y ) );
    this.tasasVariablesService.listadoPrincipal().subscribe(res => {
      this.lisTasas = res;
      this.carInformacionInicial = false;
      this.construirTabla();
    }, error => {
      this.navServicio.setMesage(0, {
        severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
      });
      this.carInformacionInicial = false;
      this.construirTabla();
    });

  }

  construirTabla() {
    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_CODIGO'), sort: true },
      { field: 'tasaVariable', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_NOMBRETASA'), sort: true },
      { field: 'diasVigencia', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_DIASVIGENCIA'), sort: false },
      { field: 'fechaInicio', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_FECHAINICIO'), sort: false },
      { field: 'fechaFin', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_FECHAFIN'), sort: false },
      { field: 'valor', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_VALOR'), sort: false },
      { field: 'usuarioConfigura', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_USUARIOCONFIGURA'), sort: true },
      { field: 'usuarioAprueba', header: this.navServicio.buscarMensaje('TASASVARIABLES.LBL_USUARIOAPRUEBA'), sort: true },
      { field: 'habilitado', header: this.navServicio.buscarMensaje('LBL_HABILITADO'), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];
    this.carTabla = false;
  }

  crear() {
    this.router.navigate(['apl/tasas-variables/agregar']);
  }
  editar( regActualizar: any ) {
    this.router.navigate( [ 'apl/tasas-variables/actualizar/' + regActualizar.idTasaVariable ] )
  }
  visualizar( regActualizar: any ) {
    this.router.navigate( [ 'apl/tasas-variables/detalle/' + regActualizar.idTasaVariable ] )
  }

  activar(dato: any) {
    this.carTabla = true;
    this.tasasVariablesService.activar(dato.idTasaVariable).subscribe(res => {
      if (res) {
        if (res.codigoMensaje) {
          if (res.estado) {
            this.navServicio.setMesage(0, {
              severity: 'success', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
              detail: res.codigoMensaje
            });
          } else {
            this.navServicio.setMesage(0, {
              severity: 'info', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
              detail: res.codigoMensaje
            });
          }
        }
      }
      this.carTabla = false;
    }, error => {
      this.navServicio.setMesage(0, {
        severity: 'error', summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
        detail: this.navServicio.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
      });
      this.carTabla = false;
    });
  }

}
